import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router';
import ErrorBoundary from '../../components/ErrorBoundary';
import SamlContainer from './SamlContainer';

const SamlWrapper = () => {
  return (
    <ErrorBoundary>
      <Helmet>
        <title>SAML | Sage Intelligent Time</title>
      </Helmet>
      <SamlContainer>
        <Outlet />
      </SamlContainer>
    </ErrorBoundary>
  );
};

export default SamlWrapper;
